export default {
    organisationDetails: {},
    organisationAsset: [],
    notificationCount: 0,
    transactions: null,
    TransactionPageInfo: null,
    walletTransactions: [],
    // Must be null, not 0. The walletBalance getter returns this value unchanged while
    // falsy, and consumers call `walletBalance?.slice(...)`. Optional chaining
    // short-circuits on null but not on 0, so 0 throws "slice is not a function".
    walletBalance: null,
    // Every bucket per wallet (balance/escrow/lien/offer_hold/total), keyed by gToken
    // symbol. walletBalance above holds only the spendable number.
    currencyWallets: null,
    tradeBalance: 0,
    exchangeRate: 0,
    minimumWithdrawal: 0,
    pin: 0,
    currency: "",
    withdrawMethod: "",
    fundMethod: "",
    virtualAccount: {},
    features: [],
    tokens: [],
    // token: [],
    vestingSchedule: null,
    entityCard: [],
    updates: [],
    updatePage: 0,
    updatePages: 0,
    walletPage: 0,
    walletPages: 0,
    singleTokenBalance: 0,
    transactionFees: null,
    lastRaiseStage: null,
    currencyRate: null,
    minimumDeposit: null,
    investmentCategories: [],
    loans: [],
    borrowers: [],
    loanSummary: {},
    // Dashboard-wide currency scope for the credit-provider views. Amounts in
    // different currencies cannot be summed, so every credit figure is read
    // through this one selection.
    creditCurrency: "NGN",
    loanConfiguration: {},
    code: "",
    codeType: "",
    creditPage: 0,
    creditPages: 0,
    // incase of pagination for borrower table
    borrowerPage: 0,
    borrowerPages: 0,
    teamMember: {},
    teamMembers: null,
    iamGroups: {
        docs: [],
        totalDocs: 0,
        page: 1,
        totalPages: 0
    },
};